import { render } from "./EditItemPage.vue?vue&type=template&id=82f32568"
import script from "./EditItemPage.vue?vue&type=script&lang=js"
export * from "./EditItemPage.vue?vue&type=script&lang=js"

import "@/css/CreateItemPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__